import request from '@/utils/request'

// 获取感染管理质控督查表列表
export function getInfectionManagementList(params) {
  return request({
    url: '/infection-management/list',
    method: 'get',
    params
  })
}

// 提交感染管理质控表数据
export function submitInfectionManagement(data) {
  return request({
    url: '/infection-management/submit',
    method: 'post',
    data
  })
}

// 根据科室和检查人查询数据
export function queryInfectionManagement(params) {
  return request({
    url: '/infection-management/query',
    method: 'get',
    params
  })
} 

// 获取全部数据
export function getAllInfectionManagement() {
  return request({
    url: '/infection-management/all',
    method: 'get'
  })
}
